import PropTypes from 'prop-types'
import React from 'react'

const VerticalMenu = ({
  verticals,
  onVerticalClick,
  activeVertical,
  markerPosition
}) => {
  const classes = 'vertical-menu-item'

  return (
    <div className='vertical-menu-wrapper'>
      <ul className='vertical-menu ul--reset'>
        {verticals.map((item, index) => {
          const vertical = item.node
          const label = vertical.label.split('>')[0].trim()
          const isActiveVertical = activeVertical === index
          return (
            <li
              key={vertical.id}
              className={isActiveVertical ? `${classes} is-active` : classes}
            >
              <a
                className='link--inverse-menu'
                data-vertical={index}
                href=''
                onClick={onVerticalClick}
              >
                {label.length > 25
                  ? label.split(' ').slice(0, 3).join(' ')
                  : label
                }  {/** This prevents words overflow presently, can cut off words unintentionally in the future */}
              </a>
            </li>
          )
        })}
      </ul>
      <span
        className='vertical-menu__marker'
        style={{ transform: `translateY(${markerPosition}px)` }}
      />
    </div>
  )
}

VerticalMenu.propTypes = {
  activeVertical: PropTypes.number,
  verticals: PropTypes.array,
  onVerticalClick: PropTypes.func.isRequired,
  markerPosition: PropTypes.number.isRequired
}

export default VerticalMenu



// WEBPACK FOOTER //
// ./src/components/vertical-menu.js